import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LookupDataService } from '../services/lookup-data.service';

@Pipe({
  name: 'category',
  pure: true,
})
export class CategoryPipe implements PipeTransform {
  constructor(private lookupData: LookupDataService) {}

  transform(value: number | string | null | undefined): Observable<string> {
    if (value === null || value === undefined || value === '') {
      return of('الفئة غير محددة');
    }
    return this.lookupData.getOpportunityCategories({
      selectedIds: [String(value)],
      pageNumber: 1,
      pageSize: 1
    }).pipe(
      map(result => {
        const name = result.items.find(c => String(c.id) === String(value))?.name;
        return name ?? 'الفئة غير محددة';
      })
    );
  }
}
